import { render, staticRenderFns } from "./OurTeam.vue?vue&type=template&id=20bf4055&scoped=true&"
import script from "./OurTeam.vue?vue&type=script&lang=js&"
export * from "./OurTeam.vue?vue&type=script&lang=js&"
import style0 from "./OurTeam.vue?vue&type=style&index=0&id=20bf4055&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bf4055",
  null
  
)

export default component.exports